import { get } from './apiClient';
import { RawPolicy, UIPolicy } from './types';
import { mapPolicy } from './mapper';
import { 
  DashboardPoliciesResponse, 
  PolicyType,
  TenantPoliciesResponse 
} from '../components/policies/types';

export const policiesService = {
  async list(): Promise<UIPolicy[]> {
    const { data } = await get<RawPolicy[]>('/policies');
    return data.map(mapPolicy);
  },

  /**
   * Fetch dashboard policies - gets ALL policy types (DLP + AutoLabel)
   * @param searchTerm - Optional search filter
   * @param pageNumber - Page number for pagination
   * @param pageSize - Number of items per page
   * @param policyType - Optional policy type filter (drives current tab)
   */
  async fetchDashboardPolicies(
    searchTerm?: string,
    pageNumber: number = 1,
    pageSize: number = 25,
    policyType?: PolicyType,
  ): Promise<DashboardPoliciesResponse> {
    // Build query params
    const params = new URLSearchParams();
    if (searchTerm) params.append('searchTerm', searchTerm);
    if (policyType) params.append('policyType', policyType);
    params.append('pageNumber', pageNumber.toString());
    params.append('pageSize', pageSize.toString());

    const queryString = params.toString();
    const endpoint = `/policies/dashboard${queryString ? `?${queryString}` : ''}`;
    
    const { data } = await get<DashboardPoliciesResponse>(endpoint);
    return data;
  },

  /**
   * Fetch tenant-specific policies
   * @param tenantId - Target tenant ID (required)
   * @param searchTerm - Optional search filter
   * @param pageNumber - Page number for pagination
   * @param pageSize - Number of items per page
   * @param policyType - Optional policy type filter (drives current tab)
   */
  async fetchTenantPolicies(
    tenantId: string,
    searchTerm?: string,
    pageNumber: number = 1,
    pageSize: number = 25,
    policyType?: PolicyType,
  ): Promise<TenantPoliciesResponse> {
    // Build query params
    const params = new URLSearchParams();
    if (searchTerm) params.append('searchTerm', searchTerm);
    if (policyType) params.append('policyType', policyType);
    params.append('pageNumber', pageNumber.toString());
    params.append('pageSize', pageSize.toString());

    const queryString = params.toString();
    const endpoint = `/tenants/${tenantId}/policies${queryString ? `?${queryString}` : ''}`;
    
    const { data } = await get<TenantPoliciesResponse>(endpoint);
    return data;
  },
};
